import { Injectable } from "@angular/core";
import { trackEvent } from "@intercom/messenger-js-sdk";
import { BehaviorSubject } from "rxjs";

/**
 * EvaHelpService — Service global pour piloter le drawer d'aide centralisé.
 *
 * Permet à n'importe quel composant (sidebar, topbar, etc.) d'ouvrir le drawer
 * d'aide unique injecté dans le layout.
 */
@Injectable({ providedIn: "root" })
export class EvaHelpService {
  private readonly _visible$ = new BehaviorSubject<boolean>(false);
  readonly visible$ = this._visible$.asObservable();

  open(source?: string): void {
    if (source) {
      trackEvent("help-center-open", { source });
    }
    this._visible$.next(true);
  }

  close(): void {
    this._visible$.next(false);
  }

  setVisible(value: boolean): void {
    this._visible$.next(value);
  }
}
